import { types } from 'mobx-state-tree';
import {type} from "chroma-js/src/utils";

export default types
  .model('PSP', {
    id: types.maybeNull(types.integer),
    seller_id: types.maybeNull(types.integer),
    media: types.maybeNull(types.string),
    handle: types.maybeNull(types.string),
    followers: types.maybeNull(types.integer),
    transaction_count: types.maybeNull(types.integer),
    duration: types.maybeNull(types.string),
    approval_status: types.optional(types.union(types.number, types.boolean), false),
    amount_gained: types.maybeNull(types.number),
    payouts: types.maybeNull(types.number),
  })

